
import { defineComponent } from "vue";
import KTTopbar from "@/layout/header/Topbar.vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTTopbar,
  },
  setup() {
    const store = useStore();
    const toggleMenu = () => {
      store.dispatch(Actions.TOGGLE_IS_MENU_OPEN);
    };
    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      toggleMenu,
    };
  },
});
